import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import React from "react";

// Failure state for the Library tab's prompts fetch (PRD AC 3.3.1).
// Single button that swaps between "Try Again" and a disabled
// "Retrying…" spinner — no wrapping markup duplication.
const PromptsListErrorCard = ({ isRetrying, onRetry }) => (
  <div className="card mb-2">
    <div className="card-body py-3">
      <div
        className="alert alert-danger d-flex align-items-center justify-content-between mb-0"
        role="alert"
      >
        <span>
          <FontAwesomeIcon icon="fas fa-exclamation-circle" className="mr-2" />
          Unable to load templates. Please try again.
        </span>
        {isRetrying ? (
          <button
            type="button"
            className="btn btn-sm btn-outline-danger"
            disabled
          >
            <FontAwesomeIcon icon="far fa-spinner" pulse className="mr-1" />
            Retrying…
          </button>
        ) : (
          <button
            type="button"
            className="btn btn-sm btn-outline-danger"
            onClick={onRetry}
          >
            Try Again
          </button>
        )}
      </div>
    </div>
  </div>
);

PromptsListErrorCard.propTypes = {
  isRetrying: PropTypes.bool.isRequired,
  onRetry: PropTypes.func.isRequired,
};

export default PromptsListErrorCard;
